export default {
  header: {
    self: {},
    items: [{}],
  },
  aside: {
    self: {},
    items: [
      {
        title: "Início",
        root: true,
        icon: "home",
        page: "inicio",
        bullet: "dot",
      },
      {
        title: "Viagens",
        root: true,
        icon: "directions_car",
        page: "viagens",
        bullet: "dot",
      },
      {
        title: "Equipe",
        root: true,
        icon: "user_group",
        page: "equipe",
        bullet: "dot",
      },
      {
        title: "Configurações",
        root: true,
        icon: "manufacturing",
        page: "configuracoes",
        bullet: "dot",
      },
    ],
  },
};
